<template>
  <div>
    <div class="notify" :class="isOpenNotify ? 'show' : ''" v-if="isOpenNotify" ref="notify">
      <div class="d-flex align-items-center justify-content-between p-3">
        <span class="fw-700" style="font-size: 18px;">Thông báo</span>
        <div class="d-flex">
          <el-tooltip effect="dark" content="Đánh dấu tất cả đã đọc" placement="top-start" style="cursor: pointer;">
            <span class="material-icons me-1" style="font-size: 20px;" @click="readAll">done_all</span>
          </el-tooltip>
          <div class="d-flex align-items-center gap-1" style="cursor: pointer; margin-left: 10px;">
            <IconFont name="icon-navigation-setting" />
            <!-- <span>Cài đặt</span> -->
          </div>
        </div>

      </div>
      <div class="text-center" style="padding: 10px 15px 15px 15px" v-if="app.notifications.length == 0">
        Không có thông báo
      </div>
      <div v-for="(group, index) in app.notifications" :key="index">
        <div class="notify-item" style="border-top: 1px solid #EAECF2;">
          <div class="flex justify-between items-center">
            <div class="d-flex justify-content-between align-items-center" @click="toggleExpand(index)">
              <div class="d-flex align-items-center">
                <img class="nav-logo-img" style="height: 42px; width: 42px;" src="@/assets/logo.png" />
                <div style="font-size: 14px"
                  :class="{ 'unread': group.listNotification.some(noti => noti.status === 'UNREAD') }">
                  {{ getTitleNotiGroup(group) }}
                </div>
              </div>
              <div>
                <IconFont :class="['mt-1', expandedGroups[index] ? 'icon-arrow2-up' : 'icon-arrow2-down']">
                </IconFont>
              </div>
            </div>
          </div>

          <div class="mt-1">
            <div v-for="noti in (expandedGroups[index] ? group.listNotification : [group.listNotification[0]])"
              :key="noti.id" class="mb-2" :class="[{ 'group-noti': noti.status === 'UNREAD' }]"
              style="border: 1px solid #e4e7ed; padding: 6px; border-radius: 4px;" @click="readNotification(noti)">
              <div class="d-flex justify-content-between align-items-center">
                <div style="max-width: 330px;">
                  <div>
                    <div :class="['noti-text', { 'unread': noti.status === 'UNREAD' }]">
                      {{ noti.contactName }} - ({{ noti.phone }})
                    </div>
                  </div>
                  <div class="noti-details" :class="{ 'unread': noti.status === 'UNREAD' }" style="white-space: pre-wrap; word-break: break-word;">
                    {{ dateTimeFormat(noti.updateAt, "HH:mm DD/MM/YYYY") }} • {{ getMessageNoti(noti) }}
                  </div>
                </div>
                <div v-if="noti.status === 'UNREAD'" class="notification-dot"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <el-button v-if="loadMore && app.notifications.length > 0" type="info" plain style="width: 95%; align-items: center; margin: 0 10px 10px 10px"
        @click="loadMoreNoti">Xem thông báo trước</el-button>
    </div>
    <el-dialog title="Chi tiết khách hàng" @close="handleCloseRecordDetail" v-if="showNoticontact" ref="contactDetail"
      :visible.sync="showNoticontact" width="70%" center top="10vh" :close-on-click-modal="false" destroy-on-close>
      <template #title>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <span class="font-16 fw-500 me-2">Chi tiết khách hàng</span>
            <el-button type="primary" plain
              class="p-0 d-flex justify-content-center align-items-center btn-conversation" @click="dialogChat = true"
              round>
              <img class="img-logo" src="https://chat.salework.net/images/logo.png" alt="logo-chat" />
            </el-button>
            <el-button type="primary" plain
              class="p-0 d-flex justify-content-center align-items-center btn-conversation" @click="dialogZalo = true"
              round>
              <img src="@/assets/icons/zalo.svg" alt="logo-zalo" />
            </el-button>
          </div>
          <div class="d-flex align-items-center">
            <div class="me-1">Quy trình:</div>
            <el-select v-model="selectedProcessId" class="me-2 select-process" placeholder="Chọn quy trình"
              :disabled="app.globalProcessId != 'all'">
              <el-option v-for="item in processList" :key="item.processId" :label="item.name" :value="item.processId">
              </el-option>
            </el-select>
            <el-button type="success" icon="el-icon-s-goods" class="px-2" @click="openDialogOrder">
              Đơn hàng
            </el-button>
            <el-button v-if="app.omicall?.status === 'ACTIVE' || app.stringee?.status === 'ACTIVE'" type="primary"
              class="px-2" @click="clickToCall">
              <div class="d-flex align-item-center gap-1">
                <IconFont name="icon-phone" size="12px" color="#FFF" />
                Gọi điện
              </div>
            </el-button>
          </div>
        </div>
      </template>
      <ContactDetail ref="recordDetail" :contactId="contactNoti.id" :processId="selectedProcessId" :steps="steps"
        @updatedContact="handleUpdated" @close-dialog="closeRecordDetail"
        @createdNote="$bus.$emit('createdNote', [contactNoti.id])" />
    </el-dialog>
    <CreateOrder ref="createOrder" v-if="dialogOrder" @close="dialogOrder = false" :contact="contactNoti" />
  </div>
</template>


<style scoped>
@import "../../assets/css/navbar.css";
@import "../../scss/index.scss";
</style>

<script>
/* eslint-disable */
import ContactDetail from "../contact/ContactDetail.vue";
import IconFont from "../common/IconFont.vue";
import { HTTP } from "@/lib/http-common";
import workflow from "@/lib/apis/workflow";
import CreateOrder from "../contact/CreateOrder.vue";
export default {
  name: "Navbar",
  props: ["isOpenNotify"],
  components: { IconFont, CreateOrder, ContactDetail },
  data() {
    return {
      listNotification: [
        {
          id: 1,
          title: "aaaa",
          content: "aaaaaa",
          date: 123847392,
          link: "aaaaa"
        }
      ],
      listUnreadNotification: [],
      contactNoti: {},
      showNoticontact: false,
      steps: [],
      selectedProcessId: [],
      processList: [],
      dialogOrder: false,
      loadMore: true,
      expandedGroups: {}
    };
  },
  computed: {
    shouldShowSelect() {
      const currentPath = this.$route.path;
      return currentPath === "/contact" || currentPath === "/report";
    },
    countUnread() {
      return this.app.countNotification;
    },
  },
  methods: {
    handleCloseRecordDetail() {
      // if (this.recordDetail1) {
      //   this.recordDetail = false;
      //   this.recordDetail1 = false;
      //   this.getAll();
      // } else {
      //   this.recordDetail = false;
      //   this.recordDetail1 = false;
      // }
    },
    handleUpdated(isUpdated) {
      // this.recordDetail1 = isUpdated;
    },
    closeRecordDetail(updatedStatus) {
      this.showNoticontact = false;
      // if (updatedStatus) {
      //   this.recordDetail = false;
      //   // this.getAll();
      //   // this.selectedContact = {};
      // } else {
      //   this.recordDetail = false;
      //   // this.selectedContact = {};
      // }
    },
    async getLastNoteContacts(contacts) {
      const contactIds = contacts.map(c => c.id);
      let body = {
        contactIds: contactIds
      }
      const res = await HTTP.post("/api/activity/get-last-note-contacts", body);
      this.noteData = res.data;
    },
    async readAll() {
      const res = await HTTP.post("/api/notification/read-all");
      if (res.status == 'success') {
        this.app.notifications.forEach(group => {
          group.listNotification.forEach(noti => {
            noti.status = "READ";
          });
        });
      }
    },
    async readNotification(noti) {
      // this.isOpenNotify = false;
      let res = await HTTP.post("/api/notification/update-status", [noti.id]);
      if (res.status == 'success') {
        noti.status = 'READ';
        if (noti.type == 'DELETE') {
          if (this.$route.path !== '/contact') {
            this.$router.push('/contact');
          }
        } else if (noti.status == "UPDATE_EMPLOYEE") {
          if (this.app.user.type === 'EMPLOYEE') {
            let detail = JSON.parse(noti.details);
            let newEm = [];
            try {
              newEm = JSON.parse(detail.newValue);
            } catch (e) {
              return "";
            }
            if (this.$route.path !== '/contact' && !newEm.includes(this.app.user.swUsername)) {
              this.$router.push('/contact');
            }
          }
        } else {
          const res = await HTTP.get("/api/contact/get-by-id", { params: { contactId: noti.contactId } });
          if (res.error) {
            this.$message.error(res.error.message);
          }
          this.contactNoti = res.data;
          this.processList = this.contactNoti.processAndWorkflow;
          this.processList.forEach((pw) => {
            if (!pw.name || pw.name === "Không xác định") {
              const matchedProcess = this.app.processList.find((process) =>
                process.workflowList?.find((workflow) => workflow.id === pw.workflowId)
              );
              pw.name = matchedProcess ? matchedProcess.name : "Không xác định";
            }
          });
          this.selectedProcessId = this.app.globalProcessId === 'all' ? this.contactNoti.processAndWorkflow[0].processId : (this.contactNoti.processAndWorkflow.some(p => p.processId === this.app.globalProcessId)
            ? this.app.globalProcessId
            : null);
          if (this.contactNoti.status !== 'DELETED' && this.selectedProcessId != null) {
            if (this.app.user.type === 'EMPLOYEE') {
              const inListEmployee = this.contactNoti.swEmployees.some(em => em.username == this.app.user.swUsername);
              if (!inListEmployee) {
                if (this.$route.path !== '/contact') {
                  this.$router.push('/contact');
                }
              } else {
                this.showNoticontact = true;
              }
            } else {
              this.showNoticontact = true;
            }
          } else {
            if (this.$route.path !== '/contact') {
              this.$router.push('/contact');
            }
          }
        }
      } else {
        this.$alert('error', res.error.message);
      }
    },
    getTitleNotiGroup(group) {
      const length = group.listNotification.length;
      switch (group.type) {
        case "CREATE":
          // xử lý tạo mới
          return "Bạn có " + length + " khách hàng được thêm mới.";

        case "DELETE":
          // xử lý cập nhật nhân viên
          return "Bạn có " + length + " khách hàng vừa bị xóa khỏi hệ thống.";

        case "UPDATE_EMPLOYEE":
          // xử lý cập nhật nhân viên
          return "Bạn có " + length + " khách hàng được thay đổi nhân viên phụ trách.";

        case "UPDATE_PROCESS":
          // xử lý cập nhật quy trình
          return "Bạn có " + length + " khách hàng phụ trách được thêm mới quy trình.";

        case "UPDATE_WORKFLOW":
          // xử lý cập nhật luồng công việc
          return "Bạn có " + length + " khách hàng được thay đổi bước.";

        case "UPDATE_STATUS":
          // xử lý cập nhật trạng thái
          return "Bạn có " + length + " khách hàng được cập nhật trạng thái.";

        case "UPDATE_FIELD":
          // xử lý cập nhật trường dữ liệu
          return "Bạn có " + length + " khách hàng được cập nhật thông tin.";

        case "CALL":
          // xử lý cuộc gọi
          return "Bạn có " + length + " khách hàng được thực hiện cuộc gọi.";

        case "ORDER":
          // xử lý đơn hàng
          return "Bạn có " + length + " khách hàng được tạo đơn hàng.";

        case "UPDATE_PROCESS_STATUS":
          // xử lý đơn hàng
          return "Bạn có " + length + " khách hàng thay đổi trạng thái quy trình.";
        case "MENTION":
          // xử lý đơn hàng
          return "Bạn có " + length + " khách hàng mà bạn được nhắc tới.";

        default:
          console.warn("Không xác định action:", data.type);
          break;
      }
      return group.listNotification.length;
    },
    toggleExpand(index) {
      this.$set(this.expandedGroups, index, !this.expandedGroups[index]);
    },
    handleProcessChange() {
      let key = `${this.app.user.id}_${this.app.user.swUsername}`;
      this.setProcessLocalStorage(key, this.app.globalProcessId);
      this.$bus.$emit("changeProcessId");
    },
    async loadMoreNoti() {
      if (this.app.notifications.length > 0) {
        const lastNotification = this.app.notifications[this.app.notifications.length - 1];

        if (lastNotification && lastNotification.updateAt) {
          const lastNotificationDate = new Date(lastNotification.updateAt);

          if (isNaN(lastNotificationDate.getTime())) {
            console.error('Invalid updatedAt value:', lastNotification.updatedAt);
            return;
          }

          const previousDay = new Date(lastNotificationDate);
          previousDay.setDate(lastNotificationDate.getDate() - 1);

          const time = previousDay.toISOString().slice(0, 10);

          const res = await this.fetchNotification(time, 9);

          this.app.notifications = [...this.app.notifications, ...res];
          if (res == 0) {
            this.loadMore = false;
          } else {
            this.loadMore = true;
          }
        } else {
          console.error('Invalid updatedAt:', lastNotification.updatedAt);
        }
      } else {
        console.error('No notifications available.');
      }
    },
    handleClickOutside(event) {
      const notifyEl = this.$refs.notify;
      const isInsideNotify = notifyEl && notifyEl.contains(event.target);

      const isContactDetailOpen = !!this.$refs.recordDetail;
      const isCreateOrderOpen = !!this.$refs.createOrder;

      if (!isInsideNotify && !isContactDetailOpen && !isCreateOrderOpen) {
        this.$emit("closeNoti");
      }
    },
    getMessageNoti(noti) {
      switch (noti.type) {
        case "CREATE":
          // xử lý tạo mới
          return "được tạo bởi " + noti.actorUsername;

        case "DELETE":
          // xử lý đơn hàng
          return "xóa bởi " + noti.actorUsername;

        case "UPDATE_EMPLOYEE":
          // xử lý cập nhật nhân viên
          return this.getOldValue(noti) + " -> " + this.getNewValue(noti) + " bởi " + noti.actorUsername;

        case "UPDATE_PROCESS":
          // xử lý cập nhật quy trình
          return "Quy trình: " + this.getNewValue(noti) + " (Thêm bởi " + noti.actorUsername + ")";

        case "UPDATE_PROCESS_STATUS":
          // xử lý cập nhật quy trình
          return "Quy trình: " + this.getOldValue(noti) + " -> " + this.getNewValue(noti) + " (bởi " + noti.actorUsername + ")";

        case "UPDATE_WORKFLOW":
          // xử lý cập nhật luồng công việc
          return "Bước: " + this.getOldValue(noti) + " -> " + this.getNewValue(noti) + " (Cập nhật bởi " + noti.actorUsername + ")";

        case "UPDATE_STATUS":
          // xử lý cập nhật trạng thái
          return "Trạng thái: " + this.getOldValue(noti) + " -> " + this.getNewValue(noti) + " (Cập nhật bởi " + noti.actorUsername + ")";

        case "UPDATE_FIELD":
          // xử lý cập nhật trường dữ liệu
          return "cập nhật bởi " + noti.actorUsername;

        case "CALL":
          // xử lý cuộc gọi
          return "thực hiện bởi " + noti.actorUsername;

        case "ORDER":
          // xử lý đơn hàng
          return "được tạo bởi " + noti.actorUsername;
        case "MENTION":
          // xử lý đơn hàng
          return "được nhắc tới bởi " + noti.actorUsername;

        default:
          console.warn("Không xác định action:", noti.type);
          break;
      }
    },
    getOldValue(noti) {
      let detail = JSON.parse(noti.details);
      switch (noti.type) {
        case "UPDATE_STATUS": {
          const statusMesOld = detail.oldValue === "ACTIVE" ? "Đã xác nhận" : "Chờ xác nhận";
          return statusMesOld;
        }
        case "UPDATE_EMPLOYEE": {
          let oldValue = [];
          try {
            oldValue = JSON.parse(detail.oldValue);
          } catch (e) {
            return "";
          }
          return oldValue?.length > 0 ? oldValue : "";
        }
        case "UPDATE_PROCESS_STATUS": {
          let oldValue = [];
          try {
            oldValue = JSON.parse(detail.oldValue);
          } catch (e) {
            return "";
          }
          if (!Array.isArray(oldValue) || oldValue.length === 0) {
            return "";
          }

          return oldValue
            .map((item) => {
              const process = this.app.processList.find(p => p.id == item.processId);
              if (!process) return null;
              const statusLabel = item.status === 'OPEN' ? 'Mở' : 'Đóng';
              return `${process.name} (${statusLabel})`;
            })
            .filter(Boolean)
            .join(", ");
        }
        case "UPDATE_WORKFLOW": {
          let oldValue = [];
          try {
            oldValue = JSON.parse(detail.oldValue);
          } catch (e) {
            return "";
          }
          if (oldValue.length == 0) {
            return "";
          }
          let processName = this.app.processList.filter(pro => pro.id == oldValue[0].processId).map(pro => pro.name);
          return oldValue[0].title + "(" + processName + ")";
        }
      }
    },
    getNewValue(noti) {
      let detail = JSON.parse(noti.details);
      switch (noti.type) {
        case "UPDATE_STATUS": {
          const statusMesNew = detail.newValue === "ACTIVE" ? "Đã xác nhận" : "Chờ xác nhận";
          return statusMesNew;
        }
        case "UPDATE_EMPLOYEE": {
          let newEm = [];
          try {
            newEm = JSON.parse(detail.newValue);
          } catch (e) {
            return "";
          }
          return newEm?.length > 0 ? newEm : "(bỏ trống)";
        }
        case "UPDATE_PROCESS": {
          let names = this.app.processList
            .filter(process => Number(detail.newValue) == Number(process.id))
            .map(process => process.name);

          return names.join(", ");
        }
        case "UPDATE_PROCESS_STATUS": {
          let newValue = [];
          try {
            newValue = JSON.parse(detail.newValue);
          } catch (e) {
            return "";
          }
          if (!Array.isArray(newValue) || newValue.length === 0) {
            return "";
          }

          return newValue
            .map((item) => {
              const process = this.app.processList.find(p => p.id == item.processId);
              if (!process) return null;
              const statusLabel = item.status === 'OPEN' ? 'Mở' : 'Đóng';
              return `${process.name} (${statusLabel})`;
            })
            .filter(Boolean)
            .join(", ");
        }
        case "UPDATE_WORKFLOW": {
          let newValue = [];
          try {
            newValue = JSON.parse(detail.newValue);
          } catch (e) {
            return "";
          }
          let processName = this.app.processList.filter(pro => pro.id == newValue[0].processId).map(pro => pro.name);
          return newValue[0].title + "(" + processName + ")";
        }
      }
    },
    async getAllWorkflows() {
      const response = await workflow.getWorkflow();
      this.steps = response.data.sort((a, b) => a.index - b.index);
    },
    openDialogOrder() {
      this.dialogOrder = true;
    },
    async initData() {
      const key = `${this.app.user.id}_${this.app.user.swUsername}`;
      if (this.isOpenNotify) {
        const time = new Date().toISOString().slice(0, 10);
        const res = await this.fetchNotification(time, 9);
        this.app.notifications = res;
        if (this.app.countUnreadNoti !== 0) {
          this.setUnreadPreBellClick(key, this.app.countUnreadNoti);
        }
        this.app.countUnreadNoti = 0;
        this.setUnreadCountNoti(key, this.app.countUnreadNoti);
      }
    },
    redirectPage(link) {
      return link;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.getAllWorkflows();
    this.initData();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.beta {
  background-color: royalblue;
  color: white;
  font-size: 10px;
  padding: 2px 3px;
  font-weight: bold;
  border-radius: 4px;
  margin-top: 0.25rem;
}

.select-process>>>input,
i {
  background-color: rgba(10, 88, 192, 0.1);
  color: #0a58c0;
  border: 1px solid rgba(10, 88, 192, 0.4);
}

.notify {
  position: absolute;
  width: 400px;
  max-height: 600px;
  overflow-y: auto;
  right: 10px;
  background: #fff;
  top: 50px;
  z-index: 1111;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  opacity: 0;
  transform: rotateX(-90deg);
  transform-origin: top center;
  transition: opacity 0.3s ease-out;
  animation: rotateMenu 0.3s ease-in forwards;
}

@keyframes rotateMenu {
  0% {
    transform: rotateX(-90deg);
  }

  70% {
    transform: rotateX(10deg);
  }

  100% {
    transform: rotateX(0deg);
  }
}

.notify.show {
  opacity: 1;
}

.notify-item {
  padding: 10px 15px 15px 15px;
  cursor: pointer;
  text-decoration: none;
}

/* .notify-item:hover {
  background: #ced2d6;
  color: #0a58c0;
  font-weight: 600;
} */
.count-notify {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 12px;
  background: #e1002d;
  font-size: 10px;
  padding: 0 8px;
  color: #fff;
  z-index: 9;
}

.btn-conversation {
  height: 30px;
  width: 30px;
}

.img-logo {
  height: 30px;
  width: 30px;
  object-fit: contain;
}

.noti-text {
  color: #2970DD;
  font-weight: 400;
}

.unread {
  font-weight: bold !important;
}

.noti-details {
  font-size: 12px;
  color: #9497A5;
  font-weight: normal;
}

.notification-dot {
  width: 8px;
  height: 8px;
  background-color: #409EFF;
  border-radius: 50%;
  display: inline-block;
  margin-left: 8px;
}

.group-noti {
  background-color: #FAFAFA;
}
</style>
